import { render, staticRenderFns } from "./link-card.vue?vue&type=template&id=405d2491&scoped=true&"
import script from "./link-card.vue?vue&type=script&lang=js&"
export * from "./link-card.vue?vue&type=script&lang=js&"
import style0 from "./link-card.vue?vue&type=style&index=0&id=405d2491&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d2491",
  null
  
)

export default component.exports